<script setup>
import { ref, watch } from 'vue';

import Button from 'dashboard/components-next/button/Button.vue';
import Switch from 'dashboard/components-next/switch/Switch.vue';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
  isEditingView: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update', 'delete']);

const attributeValue = ref(Boolean(props.attribute.value));

// A chave era inicializada uma única vez. Quando o valor chegava depois da
// montagem (contato ainda carregando) ou mudava por fora da tela (outro painel,
// sincronização), ela continuava exibindo o estado antigo -- o atributo estava
// salvo e a interface mostrava o contrário.
watch(
  () => props.attribute.value,
  value => {
    attributeValue.value = Boolean(value);
  }
);

// Usa o próprio v-model em vez do payload do evento, como fazem os demais
// consumidores do Switch (AutoResolve, AudioTranscription, FeatureToggle):
// o ref já está atualizado quando o change dispara, e assim a gravação não
// depende do que o componente filho resolve emitir.
const handleChange = () => {
  emit('update', attributeValue.value);
};
</script>

<template>
  <div
    class="flex items-center w-full gap-2"
    :class="{
      'justify-start': isEditingView,
      'justify-end': !isEditingView,
    }"
  >
    <Switch v-model="attributeValue" @change="handleChange" />
    <Button
      v-if="isEditingView"
      variant="faded"
      color="ruby"
      icon="i-lucide-trash"
      size="xs"
      class="flex-shrink-0 opacity-0 group-hover/attribute:opacity-100 hover:no-underline"
      @click="emit('delete')"
    />
  </div>
</template>
